import { Component } from '@angular/core';

import { AppGlobals } from '@app/app.global';
import { AuthService, } from '@core/services';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent {
  homePath = this.authService.isLoggedIn ? this.appGlobals.getDefaultLandingPath(this.authService.user) : ['/login'];

  constructor(
    public authService: AuthService,
    private appGlobals: AppGlobals) {

  }
}